import { render, staticRenderFns } from "./cancer.vue?vue&type=template&id=4ecc634d&scoped=true"
import script from "./cancer.vue?vue&type=script&lang=js"
export * from "./cancer.vue?vue&type=script&lang=js"
import style0 from "./cancer.vue?vue&type=style&index=0&id=4ecc634d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc634d",
  null
  
)

export default component.exports